import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconEyeOpen: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faEye} />;
};
